import { Box, Input, InputGroup, InputLeftElement, Text } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { RiSearch2Fill } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../../components/dashboard/Layout";
import { brandPalette } from "../../../constants/brandPalette";
import ShowAssistantPassword from "../../../containers/admin/super-admin-assistants/models/show-password";
import SuperAdminAssistantsTable from "../../../containers/admin/super-admin-assistants/table";
import { getAllTeacherAssistantsRequest } from "../../../modules/admin-modules/teachersAssistant/Actions";

const SuperAdminAssistants = () => {
  const dispatch = useDispatch();
  const assistants = useSelector((state) => state.teacherassistants.teacherassistants);
  const count = Array.isArray(assistants) ? assistants.length : 0;
  const [passwordTarget, setPasswordTarget] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    dispatch(getAllTeacherAssistantsRequest());
  }, [dispatch]);

  return (
    <Layout>
      <Box px={{ base: 4, md: 8 }} pt={6} pb={2} w="100%">
        <Text
          fontSize={{ base: "32px", md: "54px" }}
          fontWeight="800"
          color={brandPalette.primary}
          fontFamily="'Amiri', 'Tajawal', sans-serif"
          lineHeight="1"
        >
          Assistants
        </Text>
        <Text mt={2} fontSize="sm" fontWeight="700" color={brandPalette.accentDark}>
          Total: {count}
        </Text>
        <Box mt={6} mb={2} maxW="520px">
          <InputGroup>
            <InputLeftElement pointerEvents="none" h="full">
              <RiSearch2Fill color="rgba(91, 13, 22, 0.5)" fontSize="18px" />
            </InputLeftElement>
            <Input
              placeholder="Search by name or phone…"
              value={searchTerm}
              borderRadius="full"
              border="1px solid"
              borderColor={brandPalette.stone}
              bg="var(--surface-raised)"
              color="var(--text-primary)"
              pl={10}
              _focus={{
                borderColor: brandPalette.primary,
                boxShadow: "0 0 0 1px rgba(91, 13, 22, 0.2)",
              }}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </InputGroup>
        </Box>
      </Box>
      <SuperAdminAssistantsTable
        searchTerm={searchTerm}
        onShowPassword={setPasswordTarget}
      />
      <ShowAssistantPassword
        data={passwordTarget}
        isOpen={Boolean(passwordTarget)}
        onClose={() => setPasswordTarget(null)}
      />
    </Layout>
  );
};

export default SuperAdminAssistants;
